export default {
  title: "Push-уведомления Wallet",
  pushsBeAbleAfterEntityModeration:
    "Создание push-рассылок будет доступно после того, как ваше юрлицо пройдет модерацию",
  toCreatePushBuyTariff:
    "Чтобы создавать push-уведомления, необходимо приобрести тариф «Промо» или «Про+»",
  noPushsYet: "Push-уведомлений пока нет",
  newPush: "Новая рассылка",

  aboutChapter: {
    title: "О подразделе",
    descriptions: [
      "В подразделе «Push-уведомления Wallet» можно создать рассылку для&nbsp;клиентов, посетивших ваши заведения, чтобы они всегда были в&nbsp;курсе новостей, акций или&nbsp;проводимых мероприятий.",
      "Все разосланные push-уведомления отображаются в виде таблицы. Нажав на&nbsp;строку в таблице, можно посмотреть торговую точку, клиентам которой была сделана рассылка, дату отправки и текст.",
    ],
    howCreatePush: {
      header: "Как сделать рассылку push-уведомлений клиентам",
      list: [
        "Нажмите на кнопку «Новая рассылка».",
        "Выберите торговую точку, клиентам которой хотите сделать рассылку.",
        "Укажите текст заголовка, например, «Праздничные скидки».",
        "Введите текст сообщения.",
        "Проверьте все данные – после создания рассылки их нельзя будет изменить!",
        "Нажмите на кнопку «Создать рассылку».",
      ],
      p1: "Клиенты получат push-уведомления в&nbsp;течение 15 минут с&nbsp;момента создания рассылки. Изменить или&nbsp;отменить созданные рассылки невозможно.",
      p2: "<span>Важно!</span> Получение push-уведомлений доступно только тем клиентам, которые добавили карту Wallet вашего заведения в&nbsp;свой смартфон.",
    },
    hotGetWalletCard: {
      header: "Как клиенту выпустить карту Wallet",
      list: [
        "Авторизоваться в мобильном приложении RC&nbsp;PAY.",
        "Выпустить Wallet карту вашего заведения.",
        "Добавить ее в&nbsp;Apple Wallet (iOS) или&nbsp;Google Pay (Android).",
      ],
    },
  },

  creatingPushNotAvailable: "Создание рассылки недоступно",
  clientsGetPushWithin: "Клиенты получат push-уведомление в течение 15 минут.",
  pushCreatedAndInProgress: "Рассылка создана и находится в обработке",

  pushCreating: "Создание рассылки",
  pushHeader: "Заголовок рассылки",
  carefullyReadText: "Внимательно прочитайте текст",
  afterCreateUCantChangeIt:
    "После создания уведомления, изменить его будет невозможно.",
  messageText: "Текст сообщения",
  createPush: "Создать рассылку",
  pushInfo: "Информация о рассылке",
};
